import React from 'react';
import { FormGroup, InputGroup, InputGroupAddon, Input } from 'reactstrap';

export const TableSearch = ({ onChange, value, ...props }) => (
  <FormGroup {...props} className="d-flex flex-grow-1 align-items-center p-1">
    <InputGroup>
      <Input
        type="text"
        bsSize="sm"
        placeholder="&#xF002; Search"
        onChange={e => onChange(e.target.value)}
        style={{
          fontFamily:"Arial, FontAwesome"
        }}
        value={value || ''}
      />
    </InputGroup>
  </FormGroup>
);

export default TableSearch;



// WEBPACK FOOTER //
// ./src/components/common/Tables/TableSearch.jsx